import RoomSection from '../room-section';

export default function SleepTab() {
    return (
        <div className="flex flex-col gap-6 md:gap-8">
            <div className="mb-2 md:mb-4">
                <h2 className="font-bold text-2xl sm:text-3xl md:text-4xl mb-3">Sleeping Arrangements</h2>
                <p className="text-base md:text-lg lg:text-xl text-gray-300">
                    Our cabin comfortably sleeps up to 12 guests across 4 well-appointed bedrooms. Each room is thoughtfully designed with comfort in mind, featuring quality linens, ample storage, and peaceful mountain views.
                </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                <RoomSection title="Master Bedroom" image="/cabin-front.jpg">
                    <div className="text-sm md:text-base space-y-2">
                        <p className="font-semibold text-green-300 text-base">1 King Bed • Sleeps 2</p>
                        <p>The spacious master bedroom offers a luxurious king-size bed with premium bedding, en-suite bathroom, and private deck access.</p>
                        <ul className="list-disc list-inside mt-2 space-y-1 text-sm">
                            <li>En-suite bathroom</li>
                            <li>Walk-in closet</li>
                            <li>Mountain views</li>
                            <li>Blackout curtains</li>
                        </ul>
                    </div>
                </RoomSection>

                <RoomSection title="Guest Bedroom 1" image="/cabin-backside-1.jpg">
                    <div className="text-sm md:text-base space-y-2">
                        <p className="font-semibold text-green-300 text-base">1 Queen Bed • Sleeps 2</p>
                        <p>Bright and airy guest bedroom featuring a comfortable queen bed and forest views.</p>
                        <ul className="list-disc list-inside mt-2 space-y-1 text-sm">
                            <li>Queen bed with quality linens</li>
                            <li>Large closet</li>
                            <li>Shared bathroom access</li>
                            <li>Forest views</li>
                        </ul>
                    </div>
                </RoomSection>

                <RoomSection title="Guest Bedroom 2" image="/cabin-backside-2.jpg">
                    <div className="text-sm md:text-base space-y-2">
                        <p className="font-semibold text-green-300 text-base">1 Queen Bed • Sleeps 2</p>
                        <p>Cozy bedroom on the main floor with a plush queen bed and generous closet space.</p>
                        <ul className="list-disc list-inside mt-2 space-y-1 text-sm">
                            <li>Queen-size bed</li>
                            <li>Main floor location</li>
                            <li>Shared full bathroom</li>
                            <li>Reading nook with chair</li>
                        </ul>
                    </div>
                </RoomSection>

                <RoomSection title="Bunk Room" image="/cabin-backside-3.jpg">
                    <div className="text-sm md:text-base space-y-2">
                        <p className="font-semibold text-green-300 text-base">4-6 Guests</p>
                        <p>Perfect for kids or groups! Features twin beds and bunk beds with plenty of storage space.</p>
                        <ul className="list-disc list-inside mt-2 space-y-1 text-sm">
                            <li>2 Twin beds</li>
                            <li>1 Twin-over-twin bunk bed</li>
                            <li>Shared full bathroom</li>
                            <li>Great for families</li>
                            <li>Extra storage</li>
                        </ul>
                    </div>
                </RoomSection>

                <RoomSection title="Additional Sleeping" image="/cabin-front.jpg">
                    <div className="text-sm md:text-base space-y-2">
                        <p className="font-semibold text-green-300">Living Room • Sleeps 2 (optional)</p>
                        <p>For larger groups, we can provide an air mattress for the spacious living room area. Please request this amenity when booking if needed.</p>
                        <ul className="list-disc list-inside mt-2 space-y-1 text-sm">
                            <li>Queen air mattress available upon request</li>
                            <li>Linens and pillows provided</li>
                            <li>Spacious open-concept living area</li>
                        </ul>
                    </div>
                </RoomSection>
            </div>

            <div className="bg-green-900 rounded-xl p-4 md:p-6 mt-2">
                <h3 className="font-bold text-lg md:text-xl mb-2">Bathroom Details</h3>
                <ul className="text-base md:text-lg space-y-2">
                    <li>• <strong>Master En-Suite:</strong> Walk-in shower, double vanity, premium toiletries</li>
                    <li>• <strong>Full Bathroom 1:</strong> Tub/shower combo, shared by Guest Bedrooms 1 & 2</li>
                    <li>• <strong>Full Bathroom 2:</strong> Shower, shared by Guest Bedroom 3 and common areas</li>
                    <li>• All bathrooms stocked with fresh towels, toilet paper, and basic toiletries</li>
                </ul>
            </div>
        </div>
    );
}